import React from 'react'
import Styles from './styles'
import StatusCard from './components/StatusCard'
import ActionsSection from './components/ActionSection'
import ReviewSection from './components/ReviewsSection'
import InsightsSection from './components/InsightsSection/InsightsSection'
import ScheduledPostsSection from './components/ScheduledPostsSection'
import {
  SearchParamsHandlerProvider,
  useSearchParamsHandler,
} from '~/contexts/FilterContext'
import { StringParam, withDefault } from 'use-query-params'
import FAQSection from './components/FAQSection'
import useAxios from 'axios-hooks'
import { Spinner } from 'reactstrap'
import { Show } from '~/components/commons'

function HomePageStructure() {
  const { query, setQuery } = useSearchParamsHandler()
  const [{ data, loading, error }] = useAxios({
    url: '/home',
    method: 'GET',
  })
  const [
    { data: reviewData, loading: reviewLoading, error: reviewError },
  ] = useAxios({
    url: '/home/reviews',
    method: 'GET',
    params: {
      period: query.reviews_period.toLowerCase(),
    },
  })
  const success = Boolean(!error && data)
  const reviewSuccess = Boolean(!reviewError && reviewData)

  const hasAccessToInsights = Boolean(Object.keys(data?.insights || {}).length)
  const hasAccessToSchedules = Boolean(data?.schedules)
  const hasAccessToReviews = Boolean(reviewData)
  const handlePeriodChange = value => {
    setQuery('reviews_period', value)
  }
  return (
    <Styles.Container>
      <Show condition={loading}>
        <Spinner
          style={{
            alignSelf: 'center',
          }}
        />
      </Show>

      <Show condition={success}>
        <Styles.StatusCardWrapper>
          <StatusCard.ALL count={data?.locations.total} />
          <StatusCard.OPEN count={data?.locations.open} />
          <StatusCard.CLOSED_TEMPORARY count={data?.locations.temp} />
          <StatusCard.CLOSED_PERMANENTLY count={data?.locations.closed} />
        </Styles.StatusCardWrapper>

        <Styles.SplitView>
          <Styles.LeftContent>
            <Show condition={hasAccessToReviews}>
              <ReviewSection
                reviewsReceived={reviewData?.total}
                reviewsAnswered={reviewData?.replied}
                reviewsStarsAvg={reviewData?.rating}
                reviewsPorcentage={
                  reviewData?.replied > 0
                    ? (reviewData?.replied / reviewData?.total) * 100
                    : 0
                }
                onChange={handlePeriodChange}
                success={reviewSuccess}
                loading={reviewLoading}
              />
            </Show>
            <Show condition={hasAccessToInsights}>
              <InsightsSection views={data?.insights?.view} />
            </Show>
            <Show condition={hasAccessToSchedules}>
              <ScheduledPostsSection
                schedules={getScheduledPosts(data?.schedules)}
              />
            </Show>
            <Show
              condition={
                [
                  hasAccessToInsights,
                  hasAccessToSchedules,
                  hasAccessToReviews,
                ].filter(Boolean).length <= 1
              }
            >
              <FAQSection />
            </Show>
          </Styles.LeftContent>
          <Styles.RightContent>
            <ActionsSection recommendedActions={data?.recommendedActions} />
          </Styles.RightContent>
        </Styles.SplitView>
      </Show>
    </Styles.Container>
  )
}

export default function HomePage() {
  return (
    <SearchParamsHandlerProvider
      queryParams={{
        reviews_period: withDefault(StringParam, '7D'),
      }}
    >
      <HomePageStructure />
    </SearchParamsHandlerProvider>
  )
}

const getScheduledPosts = arr => {
  return (
    arr?.map(el => ({
      id: el.id,
      publishedAt: el.publishedAt,
      image: el.data.post.media[0]?.sourceUrl,
      title: el.data.post.summary,
    })) || []
  )
}
